import { Link } from 'react-router-dom';

const ctaImages = [
  {
    src: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20minimalist%20icon%20representing%20news%20and%20media%20tracking%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20flat%20design%20style%2C%20soft%20gradient%20background%2C%20modern%20editorial%20aesthetic&width=120&height=120&seq=cta-img-1&orientation=squarish',
    alt: '911爆料网追踪标识1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20eye%20icon%20symbolizing%20investigation%20and%20tracking%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20flat%20design%20style%2C%20soft%20gradient%20background%2C%20modern%20editorial%20aesthetic&width=120&height=120&seq=cta-img-2&orientation=squarish',
    alt: '911爆料网追踪标识2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Abstract%20magnifying%20glass%20icon%20representing%20deep%20investigation%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20flat%20design%20style%2C%20soft%20gradient%20background%2C%20modern%20editorial%20aesthetic&width=120&height=120&seq=cta-img-3&orientation=squarish',
    alt: '911爆料网追踪标识3',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Minimalist%20bell%20notification%20icon%20symbolizing%20breaking%20news%20alerts%2C%20warm%20terracotta%20and%20cream%20color%20palette%2C%20flat%20design%2C%20soft%20gradient%20background%2C%20modern%20editorial%20style&width=120&height=120&seq=cta-img-4&orientation=squarish',
    alt: '911爆料网追踪标识4',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Abstract%20shield%20icon%20representing%20truth%20and%20protection%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20flat%20design%20style%2C%20soft%20gradient%20background%2C%20modern%20editorial%20aesthetic&width=120&height=120&seq=cta-img-5&orientation=squarish',
    alt: '911爆料网追踪标识5',
  },
];

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
          <strong>不错过任何一个瓜</strong>
        </h2>
        <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          订阅911爆料网，第一时间获取网红黑料、明星塌房、每日吃瓜推送
        </p>

        {/* Subscribe Button */}
        <Link
          to="/about"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-secondary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-secondary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          立即订阅追踪
          <i className="ri-arrow-right-line"></i>
        </Link>

        {/* Image Row */}
        <div className="mt-14 flex items-center justify-center gap-4 md:gap-6 flex-wrap">
          {ctaImages.map((img, i) => (
            <div key={i} className="w-16 h-16 md:w-20 md:h-20 rounded-2xl overflow-hidden bg-background-200">
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}